module.exports = __webpack_public_path__ + "img/academy.2692334.svg";